import { useState, useEffect } from 'react';
import { Card, Badge, Spinner } from 'react-bootstrap';
import { getManagerName } from '../../services/firebase/employeeService';

const JobDetailsSection = ({ employee, userRole }) => {
  const job = employee?.job || {};
  const [managerName, setManagerName] = useState(job.reportingManagerName || '');
  const [loadingManager, setLoadingManager] = useState(false);

  useEffect(() => {
    if (job.reportingManagerName) {
      setManagerName(job.reportingManagerName);
      return;
    }

    const mgrId = job.reportingManager;
    if (!mgrId || mgrId === 'N/A' || mgrId === 'None') {
      setManagerName('');
      return;
    }

    let isMounted = true;
    setLoadingManager(true);
    getManagerName(mgrId)
      .then((resolvedName) => {
        if (isMounted) {
          setManagerName(resolvedName || mgrId);
        }
      })
      .catch((err) => {
        console.error('Error resolving manager name:', err);
        if (isMounted) {
          setManagerName(mgrId);
        }
      })
      .finally(() => {
        if (isMounted) {
          setLoadingManager(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [job.reportingManager, job.reportingManagerName]);

  const formatDate = (date) => {
    if (!date) return 'N/A';
    try {
      // Handle Firestore Timestamp
      if (date.seconds) {
        return new Date(date.seconds * 1000).toLocaleDateString('en-IN');
      }
      // Handle string date
      if (typeof date === 'string') {
        const parsedDate = new Date(date);
        if (!isNaN(parsedDate.getTime())) {
          return parsedDate.toLocaleDateString('en-IN');
        }
      }
      // Handle Date object
      if (date instanceof Date && !isNaN(date.getTime())) {
        return date.toLocaleDateString('en-IN');
      }
      return 'Invalid Date';
    } catch (error) {
      return 'Invalid Date';
    }
  };

  return (
    <Card className="mb-3 border-0 shadow-sm rounded-3 overflow-hidden">
      <Card.Header className="bg-success text-white py-2 py-md-3">
        <h6 className="mb-0 fw-bold">Job Details</h6>
      </Card.Header>
      <Card.Body className="p-3">
        <div className="profile-field">
          <div className="profile-field-label">Employee Code:</div>
          <div className="profile-field-value">{job.employeeCode || 'N/A'}</div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">Department:</div>
          <div className="profile-field-value">{job.department || 'N/A'}</div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">Designation:</div>
          <div className="profile-field-value">{job.designation || 'N/A'}</div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">Reporting Manager:</div>
          <div className="profile-field-value">
            {loadingManager ? (
              <span className="text-muted"><Spinner animation="border" size="sm" className="me-1" />Loading...</span>
            ) : (
              managerName || job.reportingManagerName || job.reportingManager || 'N/A'
            )}
          </div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">Employment Type:</div>
          <div className="profile-field-value">
            <Badge bg="info">{job.employmentType || 'N/A'}</Badge>
          </div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">Joining Date:</div>
          <div className="profile-field-value">{formatDate(job.joiningDate)}</div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">Probation Period:</div>
          <div className="profile-field-value">{job.probationPeriod || 0} months</div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">Probation End Date:</div>
          <div className="profile-field-value">{formatDate(job.probationEndDate)}</div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">Work Location:</div>
          <div className="profile-field-value">{job.workLocation || 'N/A'}</div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">Role:</div>
          <div className="profile-field-value">
            <Badge bg="secondary" className="text-capitalize">{job.role || userRole || 'employee'}</Badge>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default JobDetailsSection;
